export type CloverLinks = {
  poweredBy: string;
  terms: string;
  privacy: string;
};

const EU_LINKS: CloverLinks = {
  poweredBy: "https://www.eu.clover.com/?lng=en-GB",
  terms: "https://www.eu.clover.com/consumer/terms",
  privacy: "https://www.eu.clover.com/privacy-policy?lng=en-GB",
};

const CA_FR_LINKS: CloverLinks = {
  poweredBy: "https://www.clover.com/ca/fr",
  terms: "https://www.clover.com/consumer/terms",
  privacy: "https://www.clover.com/ca/fr/privacy-policy",
};

const CA_EN_LINKS: CloverLinks = {
  poweredBy: "https://www.clover.com/?lng=en-ca",
  terms: "https://www.clover.com/consumer/terms",
  privacy: "https://www.clover.com/privacy-policy?lng=en-ca",
};

const DEFAULT_LINKS: CloverLinks = {
  poweredBy: "https://www.clover.com/",
  terms: "https://www.clover.com/consumer/terms",
  privacy: "https://www.clover.com/privacy-policy",
};

const LOCALE_MAP: Record<string, CloverLinks> = {
  "en-ie": EU_LINKS,
  "en-gb": EU_LINKS,
  "fr-ca": CA_FR_LINKS,
  "en-ca": CA_EN_LINKS,
};

export function getCloverLinks(locale?: string): CloverLinks {
  const norm = (locale ?? "").toLowerCase();
  return LOCALE_MAP[norm] ?? DEFAULT_LINKS;
}
